export default __webpack_public_path__ + "static/media/insect-infestation.6e35436e.svg";